import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SLEntityVersion } from './entity';
import { SLEntityService } from './entity.service';
import { NotifierService, DialogService } from '../../ui';

@Component({
  templateUrl: './entity-version-edit.component.html',
})
export class SLEntityVersionEditComponent implements OnInit {

  entity: SLEntityVersion

  constructor(
    private route: ActivatedRoute,
    private notifier: NotifierService,
  ) { }

  ngOnInit() {

    // Get the entity version
    this.notifier.startProgress();

    this.route.data.subscribe((data) => {
      this.entity = data.entity;

      this.notifier.endProgress();
    });
  }
}
